 <!-- contact us section -->

 <div class="frame-31620_1-851">
  <!-- Left Block -->
  <div class="frame-31595_1-852">
    <h2 class="text-join-our-vision-for-tomorrow-s-leaders_1-854">
      Join Our Vision for Tomorrow's Leaders
    </h2>
    <p class="text-join-hundreds-of-happy-schools-and-families-across-mumbai---pune--let-s-build-healthier--happier-futures---one-activity-at-a-time-_1-855">
      Join hundreds of happy schools and families across Mumbai & Pune. Let's build healthier,
      happier futures - one activity at a time.
    </p>
    <div class="frame-31575_1-856">
      <li>
        <!-- <a href="#"><img src="assets/ivimg/footerSvg7.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp;(+91) 985-072-1682</a> -->
        <a href="#">&nbsp; <b>Phone: </b>+91 98507 21682 / +91 97658 21682</a>
      </li>
      <li>
        <a href="#">&nbsp; <b>Email: </b>info@innovativevision.in</a>
      </li> 
      <div class="footer-social mt-1">
      <a href="#"><img src="assets/ivimg/footerSvg1.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg2.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg3.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg4.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg5.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
    </div>
    </div>
    <div class="frame-3_1-876">
      <span class="text-explore-programs_1-877" routerLink="/program">Explore Programs</span>
    </div>
  </div>

  <!-- Divider -->
  <div class="line-7_1-878"></div>

  <!-- Right Block -->
<div class="frame-31619_1-879" [formGroup]="contactForm">
  <h3 class="text-contact-us--_1-880">Contact Us -</h3>
  <div class="frame-31618_1-881">
    <div class="row g-3">
      <div class="col-12">
        <input type="text" formControlName="name" placeholder="Enter Your Name / School Name"/>
        <div class="text-danger" *ngIf="f['name'].invalid && (f['name'].touched || submitted)">
  Name is required (min 3 chars).
</div>
      </div>

      <div class="col-12 col-md-6">
        <input type="text" formControlName="contactNo" placeholder="Enter Your Contact No." />
        <div class="text-danger" *ngIf="f['contactNo'].invalid && (f['contactNo'].touched || submitted)">
  Enter a valid 10-digit number.
</div>
      </div>

      <div class="col-12 col-md-6">
        <input type="email" formControlName="emailId" placeholder="Enter Your Email ID" />
       <div class="text-danger" *ngIf="f['emailId'].invalid && (f['emailId'].touched || submitted)">
  Enter a valid email.
</div>
      </div>
    </div>

    <textarea formControlName="thoughts" placeholder="Write Your Thoughts Here"></textarea>
    <div class="text-danger" *ngIf="f['thoughts'].invalid && (f['thoughts'].touched || submitted)">
  Please enter at least 5 characters.
</div>

    <div class="frame-3_1-900" (click)="onSubmit()">
      <span class="text-send_1-901">Send</span>
    </div>
  </div>
</div>

</div>